import React from 'react';
import { BulkActions } from '../../../../enums/bulk-actions';
import { BulkPresetDropdown } from './bulk-preset-dropdown';
import { presetService } from '../../../../services/preset-service';

import style from '../bulk-actions.module.less';

export const ApplyShippingPreset = {
  id: BulkActions.applyShippingPreset.name,

  render: (onChange, model = {}) => {
    const selectedPresetId = model.presetId;
    const updatePreset = (preset, sellerShipFroms) => {
      const presetPayload = presetService.generateShipmentConfigPayload(preset, sellerShipFroms);
      const { options, presetOptions, packages } = presetPayload;

      onChange({
        ...model,
        presetId: preset.presetId,
        shippingConfiguration: {
          options,
          packages,
          ...presetOptions,
        },
      });
    };
    return (
      <BulkPresetDropdown className={style['preset-native-dropdown']} onPresetSelected={updatePreset} selectedPresetId={selectedPresetId} />
    );
  },
};
